import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import { connectionsQueryKey } from './useConnections'

import type {
	Connection,
	CreateConnection,
} from 'honeygrid-types/validators-and-types/ConnectionTypes'

interface CreateConnectionParams {
	workspaceId?: string
	connection: CreateConnection
}

export const useCreateConnection = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const navigate = useNavigate()

	return useMutation({
		mutationFn: async ({ workspaceId = '', connection }: CreateConnectionParams) => {
			if (!workspaceId) {
				throw new Error('Workspace ID is required')
			}
			return authFetch(`workspaces/${workspaceId}/connections`, {
				method: 'POST',
				body: connection,
			}) as Promise<Connection>
		},
		onSuccess: (data, { workspaceId }) => {
			if (!workspaceId) {
				throw new Error('Workspace ID is required')
			}
			queryClient.invalidateQueries({
				queryKey: connectionsQueryKey(workspaceId),
			})
			navigate(`../${data.id}`)
		},
	})
}
